import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type GameStoryList = paths['/v4/game/{slug}/articles/{type}/'];

const getGameStoryList = createRequest<GameStoryList>('/pc/v4/game/{slug}/articles/{type}');

export default getGameStoryList;
